import { useNavigate } from 'react-router-dom';
import { Button } from '../../../atoms';

export const UnpaidPayments = () => {
  const navigate = useNavigate();

  return (
    <div className='py-8 text-center'>
      <h2 className='text-primary text-xl'>Offene Zahlungen</h2>
      <p>Um einen Termin zu buchen oder ein Rezept anzufordern, begleichen Sie bitte Ihre offenen Zahlungen.</p>
      <div className='w-36 mx-auto mt-6'>
        <Button secondary={true} onClick={() => navigate('/payments')}>
          Zahlungen
        </Button>
      </div>
    </div>
  );
};
